import { render, staticRenderFns } from "./ProductoEmpresaRegistrarLayout.vue?vue&type=template&id=79fc92d7&scoped=true&"
import script from "./ProductoEmpresaRegistrarLayout.vue?vue&type=script&lang=js&"
export * from "./ProductoEmpresaRegistrarLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProductoEmpresaRegistrarLayout.vue?vue&type=style&index=0&id=79fc92d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc92d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
